export default __webpack_public_path__ + "static/pro@mob-fc48220b7ed811aa91485c92838c5617.jpg";